import { render, staticRenderFns } from "./Single-Leave-Detail.vue?vue&type=template&id=2adbf472&scoped=true"
import script from "./Single-Leave-Detail.vue?vue&type=script&lang=js"
export * from "./Single-Leave-Detail.vue?vue&type=script&lang=js"
import style0 from "./Single-Leave-Detail.vue?vue&type=style&index=0&id=2adbf472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adbf472",
  null
  
)

export default component.exports